import React, { useMemo } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { useSheinShop } from '@/shein-platform/context/SheinShopContext';
import '@/styles/ipe/workbench/PlatformProductManagePage.css';
import '@/styles/shein-platform/shein-product-ops.css';

/**
 * 产品管理内容壳：页头已去掉，二级菜单在侧栏，此处只承载主内容。
 */
export default function ProductOpsLayout() {
  const { activeShop } = useSheinShop();
  const shopLabel = useMemo(
    () => activeShop?.shopName || '未选择店铺',
    [activeShop],
  );

  return (
    <div className="shein-product-ops shein-product-ops--wide" data-testid="shein-product-ops">
      <div className="shein-product-ops__workspace">
        <div className="shein-product-ops__content shein-product-ops__content--flush">
          <Outlet context={{ shopLabel }} />
        </div>
      </div>
    </div>
  );
}

export function useProductOpsContext() {
  return useOutletContext() || {};
}
